<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{'bg-bluegrey navbar-dark': type === 'default'}"
  >
    <!-- Search form -->
    <!-- <b-form class="navbar-search form-inline mr-sm-3"
          :class="{'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light'}"
          id="navbar-search-main">
      <b-form-group class="mb-0">
        <b-input-group class="input-group-alternative input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <b-form-input placeholder="Search" type="text"> </b-form-input>
        </b-input-group>
      </b-form-group>
      <button type="button" class="close" data-action="search-close" data-target="#navbar-search-main" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </b-form> -->
    <!-- Navbar links -->
    <b-navbar-nav class=" align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler"
             :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      <base-dropdown v-if="0" class="nav-item"
                     tag="li"
                     title-classes="nav-link"
                     title-tag="a"
                     icon="ni ni-bell-55"
                     menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden">
        <template>
          <!-- Dropdown header -->
          <div class="px-3 py-3">
            <h6 class="text-sm text-muted m-0">{{language_terms['YOU_HAVE']}} <strong class="text-primary">{{notifications.length}}</strong> {{language_terms['NOTIFICATIONS']}}.</h6>
          </div>
          <!-- List group -->
          <b-list-group flush>
            <b-list-group-item action href="javascript:void(0)" v-for="(notification, index) in notifications" :key="index" @click="clickonNotification(notification)">
              <b-row align-v="center">
                <b-col md="auto">
                  <!-- Avatar -->
                  <!-- <b-img alt="Image placeholder" src="/img/theme/team-3.jpg" class="avatar" rounded="circle" /> -->
                  <avatar :username="notification.sender_user_name"></avatar>

                </b-col>
                <b-col class="ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">{{notification.sender_user_name ? notification.sender_user_name.toUpperCase() : ""}}</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>{{notification.time_send}} {{language_terms['AGO']}}</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">{{notification.subject}} <b>{{notification.remarks}}</b></p>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
          <!-- View all -->
          <!-- This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add -->
          <a href="javascript:void(0)"  class="dropdown-item text-center text-primary font-weight-bold py-3" @click="viewAllNotifcations" v-if="notifications.length > 0">{{language_terms['VIEW_ALL']}}</a>
        </template>
      </base-dropdown>
      <!-- <base-dropdown menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link"
                     icon="ni ni-ungroup">
        <template>
          <b-row class="shortcuts px-4">
            <a href="#!" class="col-4 shortcut-item">
                    <span class="shortcut-media avatar rounded-circle bg-gradient-red">
                      <i class="ni ni-calendar-grid-58"></i>
                    </span>
              <small>Calendar</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
                    <span class="shortcut-media avatar rounded-circle bg-gradient-orange">
                      <i class="ni ni-email-83"></i>
                    </span>
              <small>Email</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
                    <span class="shortcut-media avatar rounded-circle bg-gradient-info">
                      <i class="ni ni-credit-card"></i>
                    </span>
              <small>Payments</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
                    <span class="shortcut-media avatar rounded-circle bg-gradient-green">
                      <i class="ni ni-books"></i>
                    </span>
              <small>Reports</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
                    <span class="shortcut-media avatar rounded-circle bg-gradient-purple">
                      <i class="ni ni-pin-3"></i>
                    </span>
              <small>Maps</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
                    <span class="shortcut-media avatar rounded-circle bg-gradient-yellow">
                      <i class="ni ni-basket"></i>
                    </span>
              <small>Shop</small>
            </a>
          </b-row>
        </template>
      </base-dropdown> -->
      <base-dropdown menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link" :hideArrow="true">
        <img :src="`/flag-icons/${selected_icon}.png`" slot="title" />
        <template>
          <b-row class="px-4">
            <a href="javascript:void(0)" class="col-6 mb-3" v-for="(lang, index) in languages" :key="index" @click="changeLanguage(lang)">
                <!-- <img src="/flag-icons/en.png"> -->
                <img :src="`/flag-icons/${lang.icon}.png`" class="mr-3">
                <span style="color:black">{{lang.language_name}}</span>
            </a>
          </b-row>
        </template>
      </base-dropdown>
      
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
          <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
                  <span class="avatar avatar-xs rounded-circle">
                    <img alt="Image placeholder" src="/img/theme/user-avartar.png">
                  </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{login_user_name}}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">{{language_terms['WELCOME']}}!</h6>
          </b-dropdown-header>
          <b-dropdown-item href="#!">
            <i class="ni ni-single-02"></i>
            <span>{{language_terms['MY_PROFILE']}}</span>
          </b-dropdown-item>
          <!-- <b-dropdown-item href="#!">
            <i class="ni ni-settings-gear-65"></i>
            <span>{{language_terms['SETTING']}}</span>
          </b-dropdown-item>
          <b-dropdown-item href="#!">
            <i class="ni ni-calendar-grid-58"></i>
            <span>{{language_terms['ACTIVITY']}}</span>
          </b-dropdown-item>
          <b-dropdown-item href="#!">
            <i class="ni ni-support-16"></i>
            <span>{{language_terms['SUPPORT']}}</span>
          </b-dropdown-item> -->
          <div class="dropdown-divider"></div>
          <b-dropdown-item href="javascript:void(0)" @click="logout" >
            <i class="ni ni-user-run"></i>
            <span>{{language_terms['LOGOUT']}}</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
        <loading :active.sync="isLoading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
        </loading>
  </base-nav>
  
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import { mapState } from "vuex";

import Avatar from 'vue-avatar'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    Avatar,
    Loading
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
     ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        notifications: state => state.notifications.notifications,
        is_mark_as_read: state => state.notifications.marks_as_read,
        active_languages:state => state.languages.active_languages
      }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      isLoading:false,
      login_user_name:"User",
      selected_icon:'en',
      language_code:"en",
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      languages:[],
      // languages:[
      //       {
      //         code:"en",
      //         name:"English",
      //         icon:'en'
      //       },
      //       {
      //         code:"zh-hant",
      //         name:"中文(繁体)",
      //         icon:'hk'
      //       }
      //   ],
    };
  },
  async mounted()
  {
    if(localStorage.user) {
      let user = await localStorage.getItem('user')
      let data = localStorage.getItem("selected_langauge")

      if(data)
      {
        this.language_code = data
        this.getSelectedIcon(this.language_code)
      }
 

      if(user)
      {
        user = JSON.parse(user);
        this.login_user_name = user.name

      }
      await this.$store.dispatch("languages/fetchActiveLanguages", {})
      this.languages = this.active_languages
      await this.retrieveNotifications();
    }
    
  },
  methods: {
    viewAllNotifcations()
    {
      this.$router.push('/approval-requests')
    },
    async clickonNotification(notification)
    {
      if(notification)
      {
          //mark as read
          //RECEIVE_NOTIFICATION_MARK_READ
          this.isLoading = true
          await this.$store.dispatch("notifications/marKNotificationAsRead", {id:notification.id})

          if(this.is_mark_as_read)
          {
            this.$router.push(notification.url + "?mode=approval")
          }
           
          this.isLoading = false
      }
    },
    async retrieveNotifications()
    {
        //
        await this.$store.dispatch("notifications/retrieveNotifications", {})
    },
    getSelectedIcon(code){
        const result = this.languages.filter(lang => lang.code == code);
        if(result.length > 0){
          this.selected_icon = result[0].icon
        }
        else
        {
          this.selected_icon = 'en'
        }
    },
    setLang()
    {
        this.$store.dispatch("languages/setSelectedLang", this.language_code);
    },
    async changeLanguage(lang)
    {
      if(lang.code)
      {
        this.language_code = lang.code
        this.setLang();
        this.getSelectedIcon(this.language_code)
      }
    },
    async logout()
    {

      await this.$store.dispatch("auth/logout");
      this.$router.push("/login")

    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);

    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
